import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import DFNavbar from "../components/Navbar";
import { HOME_ROUTE } from "../consts/routes";
import { Link } from "react-router-dom";

/**
 * NOT FOUND画面
 * @returns
 */
const CommonNotFound = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <DFNavbar bottomPadding={true} />
            <div className="mx-auto flex-grow items-center justify-center px-6 py-8 pt-20">
                <h1 className="h1-common py-5">{t("CommonNotFound.commonNotFoundTitle")}</h1>
                <ul className="mx-auto ml-10 list-disc text-gray-700">
                    <li>{t("CommonNotFound.commonNotFoundText1")}</li>
                    <li>{t("CommonNotFound.commonNotFoundText2")}</li>
                </ul>

                {/* トップ画面へ戻る */}
                <div className="flex justify-center pt-10">
                    <Link to={HOME_ROUTE}>
                        <button className="btn-secondary px-5">{t("CommonNotFound.backToTop")}</button>
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
};
export default CommonNotFound;
